module.exports = __webpack_public_path__ + "img/newborn-baby-parent-holding.174f5952.png";